import { BuildingSelectModal } from "@senciamatch/frontend/components/BuildingSelectModal";
import { StaffSelectModal } from "@senciamatch/frontend/components/StaffSelectModal";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import type { Building } from "@senciamatch/shared/models/building";
import type { Staff } from "@senciamatch/shared/models/staff";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const NewNGPage = () => {
  const [staff, setStaff] = useState<Staff | null>(null);
  const [staffModalOpen, setStaffModalOpen] = useState(false);
  const [building, setBuilding] = useState<Building | null>(null);
  const [buildingModalOpen, setBuildingModalOpen] = useState(false);

  const createNG = trpc.createBuildingNGStaff.useMutation();
  const getBuildingNGStaffs = trpc.getBuildingNGStaffs.useQuery();
  const navigate = useNavigate();

  const canSubmit = building && staff;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">NGマッチング条件追加</h2>
      <div className="flex-grow flex flex-col bg-white border border-base-100 px-8 max-w-[600px]">
        <div className="flex flex-col gap-8 mt-8">
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="text-sm text-gray-500">
              物件名
            </label>
            <p className="flex flex-row gap-2">
              {building ? building.name : "物件を選択してください"}
              <button type="button" className="text-primary-700" onClick={() => setBuildingModalOpen(true)}>
                {building ? "変更" : "選択"}
              </button>
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="text-sm text-gray-500">
              スタッフ名
            </label>
            <p className="flex flex-row gap-2">
              {staff ? staff.name : "スタッフを選択してください"}
              <button type="button" className="text-primary-700" onClick={() => setStaffModalOpen(true)}>
                {staff ? "変更" : "選択"}
              </button>
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <button
              type="button"
              onClick={() => {
                if (!building || !staff) return;
                createNG.mutate(
                  {
                    buildingId: building.id,
                    staffId: staff.id,
                  },
                  {
                    onSuccess: () => {
                      getBuildingNGStaffs.refetch();
                      navigate("/ngs");
                    },
                  },
                );
              }}
              className="w-full bg-[#00AF31] text-white p-2 rounded-md"
              disabled={!canSubmit}
            >
              登録
            </button>
          </div>
        </div>
      </div>
      {staffModalOpen && (
        <StaffSelectModal
          onSelect={setStaff}
          onClose={() => {
            setStaffModalOpen(false);
          }}
        />
      )}
      {buildingModalOpen && <BuildingSelectModal onSelect={setBuilding} onClose={() => setBuildingModalOpen(false)} />}
    </div>
  );
};
